@if (client$ | async; as client) {
  @if (dienstId$ | async; as dienstId) {
    @if (signaalkaarten$ | async; as signaalkaarten) {
      <zah-client-header [client]="client"
        label="Signaalkaarten">
      </zah-client-header>
      <div class="content">
        <zah-signaalkaarten [signaalkaarten]="signaalkaarten"
          (signaalkaartClicked)="onSignaalkaartClicked($event, client, dienstId)">
        </zah-signaalkaarten>
        <button mat-mini-fab
          color="primary"
          class="back-button"
          (click)="navigateBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
    }
  }
}
